var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xh-wrap"
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('img', {
    staticClass: "logo md-hidden",
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/media_logo_pc.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "passport_other media_tips"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('mediacenter.followOfficialAccount')))]), _vm._v(" "), _c('span', [_vm._v("Reporters from other countries and areas please click here")])]), _vm._v(" "), _c('footer', {
    staticClass: "fs-20 color-fff"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('pagebottom.copyright')) + "\n      "), _c('a', {
    staticClass: "color-fff",
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.miit.gov.cn/"
    }
  }, [_vm._v("粤ICP备17092841号-4")])])])])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-541da1c5","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mediaCenter/mediaApply.vue
// module id = null
// module chunks = 